import React from 'react'
// import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core';
import NavigateBefore from '@material-ui/icons/NavigateBefore';
import NavigateNext from '@material-ui/icons/NavigateNext';
import {
  TableContainer,
  TableFooter,
  TotalElementCont,
  PaginationContainer,
  DoubleArrowImg,
  ArrowContainer,
  PageNumbers,
  NumberPage,
  ShowElementCont,
  useInputStyles,
  PurpleCheckbox
} from './styled';

const ListItems = ({ children, currentPage, total, changePage, perPage, onChangePerPage, selectAllCheckBox, totalPages }) => {

  const inputClasses = useInputStyles();

  const getPages = (current, total) => {
    let pages = []
    if (current > 2 && current !== total) {
      pages = total > 3 ? [current - 1, current, current + 1] : [1, 2, 3]
    } else if (current === total && total > 2) {
      pages = [current - 2, current - 1, current]
    } else if (current === total && total === 1) {
      pages = [1]
    } else {
      pages = total === 2 ? [1, 2] : [1, 2, 3]
    }
    return pages
  }

  const renderPageNumbers = (current, totalPages, changePage) => {
    const pages = getPages(current, totalPages);
    return pages.map((p, i) => <NumberPage key={i} active={p === current ? true : false} onClick={() => changePage(p, perPage)}>{p}</NumberPage>)
  }

  return (
    <>
      <TableContainer>
        {children}
      </TableContainer>
      {total > 0 && (
        <TableFooter>
            <>
              <TotalElementCont>
                <PurpleCheckbox onClick={selectAllCheckBox} />
                <span className='listitems-txt'>Seleccionar todo</span>
              </TotalElementCont>
              <PaginationContainer>
                <DoubleArrowImg onClick={() => currentPage === 1 ? null : changePage(1, perPage)} src={require('../../../../assets/icons/page-first.svg')} />
                <ArrowContainer onClick={() => currentPage === 1 ? null : changePage(currentPage - 1, perPage)}>
                  <NavigateBefore style={{ color: '#fff' }} />
                </ArrowContainer>
                <PageNumbers>
                  {renderPageNumbers(currentPage, totalPages, changePage)}
                </PageNumbers>
                <ArrowContainer onClick={() => currentPage === totalPages ? null : changePage(currentPage + 1, perPage)}>
                  <NavigateNext style={{ color: '#fff' }} />
                </ArrowContainer>
                <DoubleArrowImg onClick={() => currentPage === totalPages ? null : changePage(totalPages, perPage)} src={require('../../../../assets/icons/page-last.svg')} />
              </PaginationContainer>
              <ShowElementCont>
                <span>Mostrar</span>
                <TextField
                  variant='outlined'
                  value={perPage}
                  onChange={onChangePerPage}
                  InputProps={{ classes: inputClasses }} />
                <span>elementos por pagina</span>
              </ShowElementCont>
            </>
        </TableFooter>
      )
      }
    </>
  )
}

const voidFunc = () => {}

ListItems.defaultProps = {
  changePage: voidFunc,
  onChangePerPage: voidFunc,
  selectAllCheckBox: voidFunc
}

export default ListItems
